import React from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

export const SettingsIcon = (props: SvgIconProps) => (
  <SvgIcon width="28" height="28" viewBox="0 0 28 28" {...props}>
    <path
      d="M10.5899 15.21C11.1599 15.79 12.9799 17.62 13.5899 18.28C10.6599 21.37 7.91989 24.28 7.50989 24.68C7.29465 24.8762 7.04076 25.0253 6.76451 25.1177C6.48825 25.2101 6.19574 25.2437 5.90573 25.2164C5.61572 25.1891 5.33462 25.1015 5.08046 24.9592C4.82631 24.8168 4.60471 24.623 4.42989 24.39C3.10989 23 3.56989 21.92 3.99989 21.44C4.42989 20.96 7.49989 18.15 10.5899 15.21Z"
      stroke="white"
      stroke-width="1.5"
      stroke-miterlimit="10"
    />
    <path
      d="M23.1497 10.11C22.713 10.0835 22.2766 10.166 21.8797 10.35C20.6161 11.2833 19.4043 12.2848 18.2497 13.35C17.7297 13.91 17.7897 13.91 16.4297 15.35L13.4297 12.35C14.8897 10.98 14.8897 11.04 15.4297 10.51C16.5977 9.45209 17.703 8.32683 18.7397 7.13997C18.908 6.78331 18.9967 6.39432 18.9997 5.99997C18.9997 4.99997 20.2397 2.23997 23.6697 2.92997L21.4697 5.12997C21.4032 5.19514 21.3503 5.27293 21.3142 5.35879C21.2782 5.44465 21.2596 5.53684 21.2596 5.62997C21.2596 5.72309 21.2782 5.81528 21.3142 5.90114C21.3503 5.987 21.4032 6.06479 21.4697 6.12997L22.9997 7.63997C23.0641 7.70774 23.1417 7.7617 23.2277 7.79858C23.3136 7.83545 23.4062 7.85447 23.4997 7.85447C23.5932 7.85447 23.6858 7.83545 23.7717 7.79858C23.8577 7.7617 23.9352 7.70774 23.9997 7.63997L26.1997 5.43997C26.9197 8.86997 24.1897 10.14 23.1497 10.11Z"
      stroke="white"
      stroke-width="1.5"
      stroke-miterlimit="10"
    />
    <path
      d="M8.51953 13.1L11.3195 10.3"
      stroke="white"
      stroke-width="1.5"
      stroke-miterlimit="10"
    />
    <path
      d="M6.40078 23.3001C6.87022 23.3001 7.25078 22.9195 7.25078 22.4501C7.25078 21.9807 6.87022 21.6001 6.40078 21.6001C5.93134 21.6001 5.55078 21.9807 5.55078 22.4501C5.55078 22.9195 5.93134 23.3001 6.40078 23.3001Z"
      fill="white"
    />
    <path
      d="M20.1095 24.82C19.7095 24.4 10.5895 15.21 10.5895 15.21L7.9995 12.56C7.9995 12.56 6.4595 11.14 5.6695 11.93C5.0995 12.5 5.1695 12.93 5.2595 13.1C5.28101 13.1327 5.29247 13.1709 5.29247 13.21C5.29247 13.2491 5.28101 13.2874 5.2595 13.32L4.3495 14.27L4.2295 14.34C3.91801 14.4052 3.59447 14.3817 3.2957 14.2721C2.99693 14.1625 2.73493 13.9712 2.5395 13.72C1.5895 12.72 1.6395 12.28 1.8595 12.05C2.0795 11.82 2.9995 10.9 3.2995 10.62C3.32193 10.6058 3.34794 10.5983 3.3745 10.5983C3.40106 10.5983 3.42707 10.6058 3.4495 10.62C3.6595 10.7 4.2195 10.89 4.4495 10.62C4.6795 10.35 4.4495 9.12004 4.5695 8.89004C4.6895 8.66004 9.2095 4.27004 12.2195 2.79004L12.6995 3.28004C12.6995 3.28004 8.4095 6.77004 10.6995 9.86004L13.3695 12.46L23.0695 21.82C23.3731 22.222 23.5065 22.7272 23.441 23.2267C23.3756 23.7262 23.1164 24.1799 22.7195 24.49C22.4111 24.8712 21.9673 25.1183 21.4809 25.1798C20.9944 25.2413 20.5031 25.1124 20.1095 24.82Z"
      fill="white"
      fill-opacity="0.2"
      stroke="white"
      stroke-width="1.5"
      stroke-miterlimit="10"
    />
  </SvgIcon>
);
